const API_BASE = process.env.REACT_APP_API_BASE_URL || 'http://localhost:8000';

class CommunityApiService {
  async getCommunityStats(forceRefresh = false) {
    const url = forceRefresh ?
      `${API_BASE}/api/community/stats?refresh=true` :
      `${API_BASE}/api/community/stats`;

    const response = await fetch(url);

    if (!response.ok) {
      throw new Error('Failed to fetch community stats');
    }

    return response.json();
  }

  async getCommunityActivity(limit = 10) {
    const response = await fetch(`${API_BASE}/api/community/activity?limit=${limit}`);

    if (!response.ok) {
      throw new Error('Failed to fetch community activity');
    }

    return response.json();
  }

  async getFeaturedModels() {
    const response = await fetch(`${API_BASE}/api/community/featured`);

    if (!response.ok) {
      throw new Error('Failed to fetch featured models');
    }

    return response.json();
  }

  async getLeaderboard(category = 'speedup', limit = 10) {
    const response = await fetch(`${API_BASE}/api/community/leaderboard?category=${category}&limit=${limit}`);

    if (!response.ok) {
      throw new Error('Failed to fetch leaderboard');
    }

    return response.json();
  }

  async logActivity(activityData) {
    const response = await fetch(`${API_BASE}/api/community/activity/log`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(activityData),
    });

    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.detail || 'Failed to log activity');
    }

    return response.json();
  }

  async checkHealth() {
    try {
      const response = await fetch(`${API_BASE}/api/health`);
      return response.ok;
    } catch {
      return false;
    }
  }

  // Helper method to format time ago
  formatTimeAgo(dateString) {
    const date = new Date(dateString);
    const now = new Date();
    const diffMs = now - date;
    const diffSecs = Math.floor(diffMs / 1000);
    const diffMins = Math.floor(diffSecs / 60);
    const diffHours = Math.floor(diffMins / 60);
    const diffDays = Math.floor(diffHours / 24);

    if (diffSecs < 60) {
      return 'Just now';
    } else if (diffMins < 60) {
      return `${diffMins} minute${diffMins !== 1 ? 's' : ''} ago`;
    } else if (diffHours < 24) {
      return `${diffHours} hour${diffHours !== 1 ? 's' : ''} ago`;
    } else if (diffDays < 7) {
      return `${diffDays} day${diffDays !== 1 ? 's' : ''} ago`;
    } else {
      return date.toLocaleDateString();
    }
  }

  // Helper method to get activity color by type
  getActivityTypeColor(activityType) {
    const colors = {
      'deployment': 'bg-green-500',
      'optimization': 'bg-purple-500',
      'merge': 'bg-blue-500',
      'upload': 'bg-yellow-500',
      'default': 'bg-gray-500'
    };
    return colors[activityType] || colors.default;
  }

  // Helper method to get activity type label
  getActivityTypeLabel(activityType) {
    const labels = {
      'deployment': 'Deployed',
      'optimization': 'Optimized',
      'merge': 'Merged',
      'upload': 'Uploaded',
      'default': 'Activity'
    };
    return labels[activityType] || labels.default;
  }
}

const communityApiService = new CommunityApiService();
export default communityApiService;